import { ORDER_TYPES } from '@exodus/fiat-client';
import { createSelector } from 'reselect';

import type { FiatProviderAssetList } from './types.js';
import exodus from '../../exodus.js';
import selectors from '../selectors.js';

const isAvailableSelector = createSelector(
  selectors.fiatRamp.loaded,
  selectors.fiatRamp.country,
  selectors.fiatRamp.cryptoAssets,
  selectors.fiatRamp.isAssetSupportedByOrderType,
  selectors.enabledAssets.getIsEnabled,
  (isReady, country, cryptoAssets, isAssetSupported, getIsEnabled) => {
    let hasBuyAsset = false;
    let hasBuyCountry = false;
    let hasSellAsset = false;
    let hasSellCountry = false;

    if (!isReady) {
      return [undefined, undefined];
    }

    for (const asset of Object.values(cryptoAssets as FiatProviderAssetList)) {
      if (!getIsEnabled(asset.name)) {
        continue;
      }

      if (isAssetSupported(asset.name, ORDER_TYPES.buy)) {
        hasBuyAsset = true;
      }

      if (isAssetSupported(asset.name, ORDER_TYPES.sell)) {
        hasSellAsset = true;
      }

      if (hasBuyAsset && hasSellAsset) {
        break;
      }
    }

    if (!hasBuyAsset && !hasSellAsset) {
      return [false, false];
    }

    const countryProviders: [
      string,
      { isBuySupported: boolean; isSellSupported: boolean },
    ][] = Object.entries(country?.providers || {});

    for (const [
      provider,
      { isBuySupported, isSellSupported },
    ] of countryProviders) {
      if (
        isBuySupported &&
        exodus.fiatRamp.getProviderEnabled(provider, ORDER_TYPES.buy)
      ) {
        hasBuyCountry = true;
      }

      if (
        isSellSupported &&
        exodus.fiatRamp.getProviderEnabled(provider, ORDER_TYPES.sell)
      ) {
        hasSellCountry = true;
      }

      if (hasBuyCountry && hasSellCountry) {
        break;
      }
    }

    const isBuyAvailable = hasBuyAsset && hasBuyCountry;
    const isSellAvailable = hasSellAsset && hasSellCountry;

    return [isBuyAvailable, isSellAvailable];
  },
);

export default isAvailableSelector;
